import ComingSoon from "@/components/ComingSoon";

export default function MentionsLegales() {
    return (
        <ComingSoon
            testid="legal-page"
            title="Mentions légales"
            hint="Le détail des mentions légales (éditeur, hébergeur, contact, propriété intellectuelle) sera publié ici très prochainement."
        />
    );
}
